import { trackLink, trackView } from "~/helpers/trackings";
import axios from 'axios';
import { ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS } from "~/utils/constants/product";
import { ProductForProductPageType } from "~/utils/types/ProductPage";

const productPageViewLayer = {
  event: 'prod-view',
  nav1: 'landing',
  nav2: 'subscription_proposal',
  site: 'Paywall-Magento',
  tipo: 'contenuto-pay-landing',
  event_name: ["product_view"],
}

// DataLayer specifico per le pagine di Attivazioni
const attivazioniPageViewLayer = {
  event: 'page_view',
  nav1: 'attivazioni',
  nav2: 'coupon_activation',
  site: 'Paywall-Magento',
  tipo: 'contenuto-pay-attivazioni',
  event_name: ["page_view"],
  page_type: 'attivazioni',
  page_category: 'activation',
  content_group1: 'attivazioni',
  content_group2: 'coupon_page'
}

export const pageView = async (product, utmCampaign, paymentFrequencyChoosen) => {
  try {
    const prices = {full : product.prices[paymentFrequencyChoosen], discounted : product.discountedPrices[paymentFrequencyChoosen]}
    let body = { products: {} };
    body.products[product.sku] = { sku: product.sku, prices, modules: product.modules.map(el=>el.product), cartDatas: null }
    const { data : {productsDataLayer, error}, status } = await axios.post('/sole-api/trackings/getProductsDataLayer', body)
    if (status == 200) {
      trackView({
        ...productPageViewLayer,
        utmCampaign,
        ...productsDataLayer[0]
      });
      //@TODO add user_id
    }
  } catch (e) {
    // Silent error
  }
};

// Funzione specifica per il tracking delle pagine di Attivazioni
export const attivazioniPageView = async (product, utmCampaign, paymentFrequencyChoosen, slug) => {
  try {
    // Verifica che Tealium sia disponibile
    if (typeof window !== 'undefined' && !(window as any).utag) {
      setTimeout(() => attivazioniPageView(product, utmCampaign, paymentFrequencyChoosen, slug), 500);
      return;
    }

    let selectedPaymentFrequency = paymentFrequencyChoosen;
    if (!product?.prices?.[paymentFrequencyChoosen]) {
      const commonFrequencies = ['A', 'M', 'S', 'Q']; // Annuale, Mensile, Semestrale, Trimestrale
      selectedPaymentFrequency = commonFrequencies.find(freq => product?.prices?.[freq]) || Object.keys(product?.prices || {})[0];
    }

    if (!selectedPaymentFrequency || !product?.prices?.[selectedPaymentFrequency]) {
      const basicTrackingData = {
        ...attivazioniPageViewLayer,
        utmCampaign: utmCampaign || slug,
        campaign_name: utmCampaign || slug,
        page_name: `attivazioni/${slug}`,
        page_url: typeof window !== 'undefined' ? window.location.href : '',
        page_title: product?.title || `Attivazioni ${slug}`,
        product_name: product?.title,
        product_sku: product?.sku,
      };
      
      trackView(basicTrackingData);
      return;
    }

    const prices = {
      full: product.prices[selectedPaymentFrequency], 
      discounted: product.discountedPrices?.[selectedPaymentFrequency] || product.prices[selectedPaymentFrequency]
    };
    
    let body = { products: {} };
    body.products[product.sku] = { 
      sku: product.sku, 
      prices, 
      modules: product.modules?.map(el => el.product) || [], 
      cartDatas: null 
    };
    
    const { data: { productsDataLayer, error }, status } = await axios.post('/sole-api/trackings/getProductsDataLayer', body);
    
    if (status == 200) {
      const trackingData = {
        ...attivazioniPageViewLayer,
        utmCampaign: utmCampaign || slug,
        campaign_name: utmCampaign || slug,
        page_name: `attivazioni/${slug}`,
        page_url: typeof window !== 'undefined' ? window.location.href : '',
        page_title: product.title || `Attivazioni ${slug}`,
        product_name: product.title,
        product_sku: product.sku,
        payment_frequency: selectedPaymentFrequency,
        ...productsDataLayer[0]
      };
      
      trackView(trackingData);
    }
    
  } catch (e) {
    // Silent error
  }
};

export const trackBuyFromProductPage = (productName, paymentFrequency?: string, callback?:Function) => {
  const obj = {
    link_id: `detail product:${productName}:procedi`,
    event_type: ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS[paymentFrequency]
  }
  trackLink(obj, callback)
}